
import {Component, Vue, Prop} from "vue-property-decorator";
import {Getter} from "vuex-class";

@Component
export default class RestrictionDialog extends Vue {
    @Prop({default: null})
    public type: string;

    @Getter private canDoInEnvCompany: (right: string) => boolean;
    @Getter private currentUser: any;
    @Getter private isMobile: boolean;

    private dialog: boolean = true;

    get restrictions() {
        return this.currentUser?.company?.currentSubscription?.Plan?.details;
    }

    get planName() {
        return this.$i18n.t(`plan.${this.currentUser?.company?.currentSubscription?.Plan?.name}.name`);
    }

    private restrictionMaxValue(type): number {
        if (type === "maxUsersPerKey" && this.currentUser?.company?.currentSubscription?.Plan?.name === "TAILOR_MADE") {
            return this.restrictions[type]
                + parseInt(this.currentUser?.company?.currentSubscription?.details?.options?.additionalUser?.number
                    || 0, 10);
        }
        if (type === "maxKeys" && this.currentUser?.company?.currentSubscription?.Plan?.name === "TAILOR_MADE") {
            return this.restrictions[type]
                + parseInt(this.currentUser?.company?.currentSubscription?.details?.options?.additionalTenKeys?.number
                    || 0, 10) * 10;
        }
        return this.restrictions[type];
    }
}
